var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('div',{staticClass:"c-subtab-button-container"},_vm._l((_vm.subtabs),function(subtab,i){return _c('ClassicSubtabButton',{key:i,attrs:{"subtab":subtab,"parent-name":_vm.tab.name}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }